import { IdentifierDTO } from '@zazume/zzm-base';

import { UserConsentsByBackgroundCheck } from '#/models/UserConsent';

import { doGet } from '../../helpers';

export const userConsents = {
  getByBackgroundCheck: (backgroundCheckId: IdentifierDTO) => () =>
    doGet<UserConsentsByBackgroundCheck>(`/user-consents/by-background-check/${backgroundCheckId}`)
};
